import React, { useState } from 'react'

import { PAYEE_TYPE } from '../../models/Payee'
import { PhoneNumber } from '../../models/PhoneNumber'
import { RecordFactory } from '../../models/RecordFactory'
import { ComponentData } from '../../utils/typing'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { PSButtonPrimary } from '../app/PSButton'
import { NumberModal } from './NumberModal'
import { DangerModal } from '../common/modals/DangerModal'
import { NumberCard } from './NumberCard'

const viewWillAppear = async ({ me: user }: PocketComponent<void>) => {
    const phoneNumbers = await RecordFactory.getInstance().loadNumbers()

    const payees = await RecordFactory.getInstance().loadPayees(
        PAYEE_TYPE.PAYEE_TYPE_ANY_EMPLOYEE_OR_CONTRACTOR
    )

    return { phoneNumbers, payees: user.sms ? [...payees, user] : payees }
}

const render = ({
    base: { showProgressBar, hideProgressBar, logAndDisplayError },
    data: { phoneNumbers, payees },
}: PocketComponentProps<ComponentData<typeof viewWillAppear>>) => {
    const [showNumberModal, setShowNumberModal] = useState<boolean>(false)

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
    const [numberToDelete, setNumberToDelete] = useState<PhoneNumber>(new PhoneNumber())

    const confirmDelete = (number: PhoneNumber) => {
        setNumberToDelete(number)
        setShowDeleteConfirmation(true)
    }

    const onConfirmDelete = async () => {
        setShowDeleteConfirmation(false)

        if (numberToDelete.id === undefined) {
            return
        }

        showProgressBar()

        const result = await RecordFactory.getInstance().deleteNumber(numberToDelete.id)

        hideProgressBar()

        if (!result.ok) {
            logAndDisplayError(result.error)
            return
        }
    }

    return (
        <div className="servicesSettings">
            <div className="header">
                <h1>Numbers</h1>
                <PSButtonPrimary
                    style={{ height: '40px', marginLeft: 'auto' }}
                    onClick={() => setShowNumberModal(true)}
                >
                    Add Number
                </PSButtonPrimary>
            </div>
            <div className="separator" />
            <div>
                {payees.map((payee) => {
                    if (payee.sms) {
                        let num = phoneNumbers.filter((u: PhoneNumber) => u.person === payee.id)[0]
                        if (num)
                            return (
                                <NumberCard
                                    key={payee.id}
                                    payee={payee}
                                    phoneNumber={num}
                                    onDelete={() => {
                                        confirmDelete(num)
                                    }}
                                />
                            )
                    }
                })}
            </div>
            {showNumberModal && (
                <NumberModal onClose={() => setShowNumberModal(false)} payees={payees} />
            )}
            {showDeleteConfirmation && (
                <DangerModal
                    title="Delete number"
                    body="Are you sure that you’d like to delete this number? When a number is deleted the system releases it and it may not be available in the future."
                    buttonText="Confirm delete"
                    onClose={() => setShowDeleteConfirmation(false)}
                    onAction={() => onConfirmDelete()}
                />
            )}
        </div>
    )
}

export const NumbersPage = usePSComponent(render, viewWillAppear)
